var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c("div", { staticClass: "comment-content-replace-row" }, [
    _c(
      "div",
      { staticClass: "comment-content-replace-row-from" },
      [
        _c("TextBox", {
          attrs: {
            placeholder: "查找",
            text: _vm.row.from,
            "change-on-blur": "",
          },
          on: {
            change: function ($event) {
              return _vm.emitChange({ from: $event, to: _vm.row.to })
            },
          },
        }),
        _vm._v(" "),
        _c(
          "VButton",
          {
            attrs: { type: "transparent", icon: "", title: "删除此项" },
            on: { click: _vm.emitDelete },
          },
          [_c("VIcon", { attrs: { size: 14, icon: "mdi-trash-can-outline" } })],
          1
        ),
      ],
      1
    ),
    _vm._v(" "),
    _c(
      "div",
      { staticClass: "comment-content-replace-row-to" },
      [
        _c(
          "VIcon",
          {
            staticClass: "comment-content-replace-row-to-icon",
            attrs: { size: 14 },
          },
          [
            _c(
              "svg",
              {
                attrs: {
                  xmlns: "http://www.w3.org/2000/svg",
                  viewBox: "0 0 24 24",
                },
              },
              [
                _c("path", {
                  attrs: {
                    d: "M20 16L14.5 21.5L13.08 20.09L16.17 17H10.5C6.91 17 4 14.09 4 10.5V4H6V10.5C6 13 8 15 10.5 15H16.17L13.09 11.91L14.5 10.5L20 16Z",
                    fill: "currentColor",
                  },
                }),
              ]
            ),
          ]
        ),
        _vm._v(" "),
        _c("TextBox", {
          attrs: {
            placeholder: "替换为",
            text: _vm.row.to,
            "change-on-blur": "",
          },
          on: {
            change: function ($event) {
              return _vm.emitChange({ from: _vm.row.from, to: $event })
            },
          },
        }),
      ],
      1
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }